var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpecialityHead(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1640,
    height: 264,
    viewBox: "0 0 1640 264",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b,.e{fill:none;}.c{opacity:0.02;clip-path:url(#b);}.d{clip-path:url(#c);}.e{stroke:#1589bb;stroke-width:2px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1,
    y1: 0.042,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf4fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ecf4fc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1640,
    height: 264,
    rx: 20,
    transform: "translate(-956 -17030)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2178,
    height: 433.013
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(956 17030)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(-1295 -17059.82)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1446 16699.82)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1135.935 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1062.633 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1259 -16587.322)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1185.698 -16587.322)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1558.193 -16617.703)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(225.193 141.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(298.495 141.882)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1445 -16363.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1371.698 -16363.824)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1634 16699.82)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1135.935 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1062.633 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1259 -16587.322)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1185.698 -16587.322)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1558.193 -16617.703)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(225.193 141.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(298.495 141.882)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1445 -16363.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1371.698 -16363.824)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1822 16699.82)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1135.935 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1062.633 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1259 -16587.322)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1185.698 -16587.322)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1558.193 -16617.703)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(225.193 141.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(298.495 141.882)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1445 -16363.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1371.698 -16363.824)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2010 16699.82)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1135.935 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1062.633 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1259 -16587.322)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1185.698 -16587.322)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1558.193 -16617.703)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(225.193 141.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(298.495 141.882)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1445 -16363.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1371.698 -16363.824)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2198 16699.82)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1135.935 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1062.633 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1259 -16587.322)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1185.698 -16587.322)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1558.193 -16617.703)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(225.193 141.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(298.495 141.882)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1445 -16363.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1371.698 -16363.824)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2386 16699.82)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1135.935 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1062.633 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1259 -16587.322)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1185.698 -16587.322)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1558.193 -16617.703)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(225.193 141.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(298.495 141.882)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1445 -16363.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1371.698 -16363.824)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2574 16699.82)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1135.935 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1062.633 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1259 -16587.322)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1185.698 -16587.322)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1558.193 -16617.703)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(225.193 141.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(298.495 141.882)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1445 -16363.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1371.698 -16363.824)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2762 16699.82)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1135.935 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1062.633 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1259 -16587.322)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1185.698 -16587.322)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1558.193 -16617.703)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(225.193 141.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(298.495 141.882)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1445 -16363.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1371.698 -16363.824)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2950 16699.82)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1135.935 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1062.633 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1259 -16587.322)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1185.698 -16587.322)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1558.193 -16617.703)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(225.193 141.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(298.495 141.882)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1445 -16363.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1371.698 -16363.824)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3138 16699.82)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1135.935 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1062.633 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1259 -16587.322)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1185.698 -16587.322)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1558.193 -16617.703)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(225.193 141.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(298.495 141.882)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1445 -16363.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1371.698 -16363.824)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3326 16699.82)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1135.935 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1062.633 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1259 -16587.322)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1185.698 -16587.322)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1558.193 -16617.703)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(225.193 141.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(298.495 141.882)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1445 -16363.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1371.698 -16363.824)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3514 16699.82)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1135.935 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1062.633 -16698.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1259 -16587.322)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1185.698 -16587.322)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1558.193 -16617.703)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(225.193 141.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(298.495 141.882)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.683,70.225H0V0H49.763V23.081h-25.7V47.963h25.7V70.225L20.3,94.289Z",
    transform: "translate(-1445 -16363.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.081,70.225H49.763V0H0V23.081H25.7V47.963H0V70.225Z",
    transform: "translate(-1371.698 -16363.824)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialityHead);
export default __webpack_public_path__ + "static/media/speciality_head.ce2fd9454fa318a0f22610ce10fb9459.svg";
export { ForwardRef as ReactComponent };